import { ArchivedFile } from '../DownloadUrlsModalButton';

import { ArchivedFilesList } from '../DownloadUrlsModalButton/components/ArchivedFilesList';

import { SimpleModalButton } from '../../../../../helpers/buttons/SimpleModalButton';

import { filesKeys, stringsKeys } from '../../../../../locales/keys';

interface ArchivedFilesModalButtonProps {
  archivedFiles: ArchivedFile[];
}

function ArchivedFilesModalButton({
  archivedFiles
}: ArchivedFilesModalButtonProps) {
  return (
    <SimpleModalButton
      childrenClassName="flex-1 overflow-y-auto px-2 z-0"
      className="underline text-gray-600 dark:text-gray-400"
      i18nText={filesKeys.restoreFiles}
      i18nTitle={stringsKeys.filesInDeepArchive}
      modalSize="3xl"
      withoutButtons
      withoutInitialFocus
    >
      {({ hideModal }) => (
        <ArchivedFilesList
          archivedFiles={archivedFiles}
          hideModal={hideModal}
        />
      )}
    </SimpleModalButton>
  );
}

export default ArchivedFilesModalButton;
